import axios from 'axios'
import { removeClass, getParent, triggerChange, triggerClick, isNull, isUndefined, isEmpty } from '../misc/Utils'
// const outsideClick = require('outside-click')
const serialize = require('form-serialize')

export default class CollectionFiltering {
    constructor() {
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.filterForm = document.getElementById('filters-form')
        this.filterList = document.querySelectorAll('.collection-filters-list')
        this.filterTopTrigger = document.querySelectorAll('.collection-filters-trigger')
        this.filterTrigger = document.querySelectorAll('.collection-filters__filter button')
        this.filterWrap = document.querySelectorAll('.collection-filters__filter fieldset')
        this.filterList = document.querySelectorAll('.collection-filters-list')

        /* Inputs */
        this.minPrice = document.querySelector('.min-price')
        this.maxPrice = document.querySelector('.max-price')
        this.sort = document.querySelector('.collection-sort-input')
        this.sortItems = document.querySelectorAll('.collection-sort-item')
        this.radio = document.querySelectorAll('.collection-filters__filter input[type="radio"]')
        this.checkbox = document.querySelectorAll('.collection-filters__filter input[type="checkbox"]')
        this.submitButton = document.getElementById('collection-filter-submit')
        this.applyButton = document.getElementById('apply-filters')
        this.clearAll = document.querySelectorAll('.collection-filter-clear')

        /* Results */
        this.checkedPriceIndex = null
        this.loader = document.querySelector('.loader')
        this.isCount = document.querySelector('.is-mobile-count')
        this.container = document.querySelector('.product-collection-container')
        this.result = document.querySelector('.product-collection-result-count')
    }

    bindEvents() {
        Array.prototype.forEach.call(this.filterTopTrigger, (element) => {
            element.addEventListener('click', this.toggleFilterDropdown.bind(this))
        })

        Array.prototype.forEach.call(this.filterTrigger, (element) => {
            element.addEventListener('click', this.toggleFilter.bind(this))
        })

        // Array.prototype.forEach.call(this.filterWrap, (element) => {
        //     //outsideClick(element, this.handleFilterWrap.bind(this))
        // })

        Array.prototype.forEach.call(this.checkbox, (element) => {
            element.addEventListener('change', this.handleCheckbox.bind(this))
        })

        Array.prototype.forEach.call(this.sortItems, (element) => {
            element.addEventListener('click', this.handleSorting.bind(this))
        })

        Array.prototype.forEach.call(this.radio, (element, i) => {
            element.addEventListener('click', this.handleRadio.bind(this, i))
        })

        Array.prototype.forEach.call(this.clearAll, (element) => {
            element.addEventListener('click', this.clearFilters.bind(this))
        })

        events.subscribe('collection.filters.submit', () => {
            this.submitButton.click()
        })

        this.filterForm.addEventListener('submit', this.submitForm.bind(this))
        this.applyButton.addEventListener('click', this.handleApply.bind(this))

        document.addEventListener('click', this.handleClickOutside.bind(this))
    }

    toggleFilterDropdown(event) {
        const list = event.target.nextElementSibling

        if (list.classList.contains('is-open')) {
            list.classList.remove('is-open')
        } else {
            removeClass(this.filterList, 'is-open')
            list.classList.add('is-open')
        }
    }

    handleClickOutside(event) {
        const outside = isNull(event.target.closest('.collection-filters__filter'))
        const submit = event.target.id === 'collection-filter-submit'
        
        if (outside && !submit) {
            removeClass(this.filterWrap, 'is-open')
        }
    }

    toggleFilter(event) {
        event.preventDefault()
        const parent = event.currentTarget.nextElementSibling

        if (parent.classList.contains('is-open')) {
            parent.classList.remove('is-open')
        } else {
            removeClass(this.filterWrap, 'is-open')
            parent.classList.add('is-open')
        }
    }

    handleFilterWrap(event) {
        const target = event.target.getAttribute('data-target')

        if (isNull(target) || isUndefined(target)) {
            removeClass(this.filterWrap, 'is-open')
        }
    }

    handleApply(event) {
        const items = document.querySelectorAll('.collection-filters-left input[type="checkbox"]:checked, .collection-filters-left input[type="radio"]:checked')
        removeClass(this.filterList, 'is-open')

        if (items.length > 0) {
            this.isCount.innerHTML = items.length
            this.isCount.classList.add('is-active')
        } else {
            this.isCount.innerHTML = ''
            this.isCount.classList.remove('is-active')
        }
    }

    handleCheckbox(event) {
        const parent = getParent(event.target, 4)
        const checked = parent.querySelectorAll('input[type="checkbox"]:checked')
        const isCount = parent.querySelector('.is-count')

        if (checked.length > 0) {
            isCount.innerHTML = checked.length
            isCount.classList.add('is-active')
        } else {
            isCount.innerHTML = ''
            isCount.classList.remove('is-active')
        }

        this.submitButton.click()
    }

    handleRadio(i, event) {
        const price = event.target.value.split('-')

        if (this.checkedPriceIndex !== i) {
            this.checkedPriceIndex = i
            this.minPrice.value = parseInt(price[0])
            this.maxPrice.value = parseInt(price[1])
        } else {
            this.minPrice.value = ''
            this.maxPrice.value = ''
            event.target.checked = false
            this.checkedPriceIndex = null
        }

        const parent = getParent(event.target, 4)
        const checked = parent.querySelectorAll('input[type="radio"]:checked')
        const isCount = parent.querySelector('.is-count')

        if (checked.length > 0) {
            isCount.innerHTML = checked.length
            isCount.classList.add('is-active')
        } else {
            isCount.innerHTML = ''
            isCount.classList.remove('is-active')
        }

        this.updatePriceState(true)
        this.submitButton.click()
    }

    handleSorting(event) {
        event.preventDefault()
        this.sort.value = event.currentTarget.getAttribute('data-target')

        removeClass(this.sortItems, 'is-active')
        event.currentTarget.classList.add('is-active')
        this.submitButton.click()
    }

    clearFilters(event) {
        event.preventDefault()
        const parent = getParent(event.target, 3)
        const isCount = parent.querySelector('.is-count')
        const inputs = parent.querySelectorAll('input[type="checkbox"], input[type="radio"]')

        isCount.innerHTML = ''
        isCount.classList.remove('is-active')

        if (!isNull(inputs)) {
            Array.prototype.forEach.call(inputs, (element, i) => {
                element.checked = false

                switch (element.type) {
                    case 'radio':
                        this.checkedPriceIndex = i
                        this.updatePriceState(false)
                        triggerClick(element)
                        break
                    default:
                        triggerChange(element)
                        break
                }
            })
        }
    }

    updatePriceState(value) {
        Array.prototype.forEach.call(this.radio, (el) => {
            el.disabled = value
        })
    }

    submitForm(event) {
        event.preventDefault()
        this.updateUrl(event)
        this.loader.classList.add('is-active')
        const url = window.location.pathname + window.location.search

        axios
            .get(url)
            .then((response) => {
                const htmlElement = document.createElement('div')
                htmlElement.innerHTML = response.data
                const content = htmlElement.querySelector('.product-collection-container').innerHTML
                const total = htmlElement.querySelector('.product-collection-result-count').innerHTML
                this.render(content, total)
            })
            .finally(() => {
                this.updatePriceState(false)
                this.loader.classList.remove('is-active')
            })
    }

    updateUrl(e) {
        const baseUrl = window.location.href.split('?')[0]

        if (window.history.replaceState) {
            const filters = serialize(e.target)

            if (isEmpty(filters)) {
                window.history.pushState({}, '', baseUrl)
            } else {
                window.history.pushState({}, '', baseUrl + '?' + filters)
            }
        }
    }

    render(content, total) {
        this.container.innerHTML = content.trim()
        this.result.innerHTML = total.trim()
    }
}
